import React from "react";

function useWorkloads() {
  const [areWorkloadsToggled, setAreWorkloadsToggled] = React.useState(false);

  return {
    areWorkloadsToggled,
    toggleWorkloads: () => setAreWorkloadsToggled((isToggled) => !isToggled),
  };
}

export { useWorkloads };
